export function reverseEnumLookup<T extends { [index: string]: string }>(
  myEnum: T,
  enumValue?: string | string[]
): keyof T | null {
  if (!enumValue) return null
  const keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue.toString())
  return keys.length > 0 ? keys[0] : null
}
